import { Link } from '@tanstack/react-router';
import { ChevronLeft } from 'lucide-react';
import { cn } from '@repo/utils';

type BackToConfig =
  | string
  | { to: string; params?: Record<string, string> };

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
  backTo?: BackToConfig;
  className?: string;
}

function BackLink({ backTo }: { backTo: BackToConfig }) {
  return (
    <div className="-mt-1 mb-1">
      {typeof backTo === 'string' ? (
        <Link to={backTo as never} className="inline-flex items-center gap-1 text-sm text-text-secondary hover:text-text-primary transition-colors w-fit">
          <ChevronLeft className="h-4 w-4" />
          Back
        </Link>
      ) : (
        <Link to={backTo.to as never} params={backTo.params as never} className="inline-flex items-center gap-1 text-sm text-text-secondary hover:text-text-primary transition-colors w-fit">
          <ChevronLeft className="h-4 w-4" />
          Back
        </Link>
      )}
    </div>
  );
}

export function PageHeader({ title, subtitle, action, backTo, className }: PageHeaderProps) {
  return (
    <div className={cn('flex flex-col sm:flex-row sm:items-start justify-between gap-4 mb-5', className)}>
      <div className="flex flex-col gap-1 min-w-0">
        {backTo && <BackLink backTo={backTo} />}
        <h1 className="font-newsreader font-semibold text-2xl sm:text-3xl leading-tight text-text-primary truncate">
          {title}
        </h1>
        {subtitle && (
          <p className="text-sm text-text-secondary">{subtitle}</p>
        )}
      </div>
      {action && (
        <div className="flex-shrink-0 flex items-center gap-2">
          {action}
        </div>
      )}
    </div>
  );
}
